import {getUrlSearch} from '@/utils/getUrlSearch';

// 获取 url 上的 tag area 相关参数
export const useTagInfo = () => {
  const {tagId, tagIdList, hasAreaQuery, h5CmsCategoryList} = getUrlSearch();

  // eslint-disable-next-line
  const tagIdParam: number | undefined = tagId ? +tagId : void 0;
  const tagIdListParam: number[] = tagIdList ? JSON.parse(tagIdList) : [];
  const hasAreaQueryParam: 0 | 1 = hasAreaQuery ? (+hasAreaQuery as 0 | 1) : 0;
  const h5CmsCategoryListParam: number[] = h5CmsCategoryList ? JSON.parse(h5CmsCategoryList) : [0];
  return {
    tagId: tagIdParam,
    tagIdList: tagIdListParam,
    hasAreaQuery: hasAreaQueryParam,
    h5CmsCategoryList: h5CmsCategoryListParam
  };
};
